document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.heloc-application-block').forEach(function (block) {
        const history = [];
        const wizardPanes = block.querySelectorAll('.heloc-application-wizard-pane[data-heloc-step-index]');
        const lastWizardStepIndex = wizardPanes.length - 1;
        const bankingCenterSelect = block.querySelector('.heloc-application-banking-center select');
        const bankingCenterCta = block.querySelector('.heloc-application-banking-center-cta');

        function getActivePane() {
            return block.querySelector('.tab-pane.active');
        }

        function showPane(selector, trackHistory) {
            const target = block.querySelector(selector);
            const trigger = block.querySelector('[data-bs-target="' + selector + '"]');

            if (!target || !trigger) {
                return;
            }

            const activePane = getActivePane();

            if (trackHistory && activePane && activePane.dataset.helocPane && activePane.dataset.helocPane.indexOf('wizard-step-') === 0) {
                history.push('#' + activePane.id);
            }

            bootstrap.Tab.getOrCreateInstance(trigger).show();
        }

        function advanceFromPane(pane) {
            const currentStepIndex = parseInt(pane.dataset.helocStepIndex, 10);

            if (currentStepIndex >= lastWizardStepIndex) {
                showPane('#' + block.id + '-positive-outcome', true);
                return;
            }

            showPane('#' + block.id + '-wizard-step-' + (currentStepIndex + 1), true);
        }

        function updateBankingCenterCta() {
            if (!bankingCenterSelect || !bankingCenterCta) {
                return;
            }

            const selectedBankingCenter = bankingCenterSelect.value;
            const baseHref = bankingCenterCta.dataset.baseHref;

            if (!selectedBankingCenter) {
                bankingCenterCta.href = baseHref;
                bankingCenterCta.classList.add('disabled');
                bankingCenterCta.setAttribute('aria-disabled', 'true');
                return;
            }

            const ctaUrl = new URL(baseHref, window.location.href);
            ctaUrl.searchParams.set('mhltid', selectedBankingCenter);

            bankingCenterCta.href = ctaUrl.toString();
            bankingCenterCta.classList.remove('disabled');
            bankingCenterCta.removeAttribute('aria-disabled');
        }

        if (bankingCenterCta) {
            bankingCenterCta.dataset.baseHref = bankingCenterCta.href;
            bankingCenterCta.setAttribute('aria-disabled', 'true');
            bankingCenterCta.addEventListener('click', function (event) {
                if (bankingCenterCta.classList.contains('disabled')) {
                    event.preventDefault();
                }
            });
        }

        if (bankingCenterSelect) {
            bankingCenterSelect.addEventListener('change', updateBankingCenterCta);
            updateBankingCenterCta();
        }

        block.querySelectorAll('.heloc-application-positive').forEach(function (button) {
            button.addEventListener('click', function () {
                if (button.dataset.helocModalTarget && window.bootstrap) {
                    const modalElement = document.getElementById(button.dataset.helocModalTarget);

                    if (modalElement) {
                        bootstrap.Modal.getOrCreateInstance(modalElement).show();
                    }
                }

                const pane = button.closest('.heloc-application-wizard-pane');

                if (pane.dataset.helocNegativeOutcomeOn === 'positive') {
                    showPane('#' + block.id + '-negative-outcome', true);
                    return;
                }

                advanceFromPane(pane);
            });
        });

        block.querySelectorAll('.heloc-application-negative').forEach(function (button) {
            button.addEventListener('click', function () {
                const pane = button.closest('.heloc-application-wizard-pane');

                if (pane.dataset.helocNegativeOutcomeOn === 'positive') {
                    advanceFromPane(pane);
                    return;
                }

                showPane('#' + block.id + '-negative-outcome', true);
            });
        });

        block.querySelectorAll('.heloc-application-back').forEach(function (button) {
            button.addEventListener('click', function () {
                const previousPaneSelector = history.pop();

                if (previousPaneSelector) {
                    showPane(previousPaneSelector, false);
                }
            });
        });
    });
});
